import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import { Calendar } from 'lucide-mui';
import { useTranslation } from 'react-i18next';
import useLimits from '../../../plan/hooks/limits';
import { initMicrosoftTeamsCalendar } from '../../../../services/integrationService';

interface ConnectMicrosoftTeamsCalendarModalProps {
  onClose: () => void;
}

const ConnectMicrosoftTeamsCalendarModal = ({
  onClose,
}: ConnectMicrosoftTeamsCalendarModalProps) => {
  const guardLimits = useLimits();
  const { t } = useTranslation();

  const handleConnectMicrosoftTeamsCalendar = async () => {
    guardLimits('meetingBot', async () => {
      const response = await initMicrosoftTeamsCalendar();
      window.location.href = response.oauthUrl;
    });
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 400,
        },
      }}
    >
      <DialogContent>
        <Stack spacing={2} alignItems="center" sx={{ py: 4 }}>
          <Calendar sx={{ width: 48, height: 48, color: 'primary.main' }} />
          <Typography variant="h6">
            {t('settings.meetingBot.microsoftTeams.connectCalendar')}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            {t('settings.meetingBot.microsoftTeams.allowAccess')}
          </Typography>
          <Button
            onClick={handleConnectMicrosoftTeamsCalendar}
            variant="contained"
            startIcon={<Calendar />}
            data-testid="connect-microsoft-teams-calendar-button"
          >
            {t('settings.meetingBot.microsoftTeams.connectButton')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectMicrosoftTeamsCalendarModal;
